import React from 'react';
import { Col, Row } from '@yme/atoms/grid';
import { Image as ImageAtom } from '@yme/atoms/image';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { HeroSectionYoutube } from '@yme/molecules/hero-section-youtube';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { DescriptionStyled, HeroComponentStyled, ImageBgStyled, ImageMaskStyled, SubtitleStyled, HeroSectionContainer, TitleStyled, } from './styled';
export function HeroSectionContentPage(props) {
    const { title, subtitle, description, backgroundImage, hasSelectorPanel, isRightToLeft, titleGridColumns = 6, youtubeId, startTime, } = props;
    const { isMobileView, isInfiniteDesktopView } = useWindowSize();
    const isVideoShowed = isInfiniteDesktopView && youtubeId;
    return (React.createElement(HeroComponentStyled, { hasSelectorPanel: hasSelectorPanel, alignItems: "flex-end", isRightToLeft: isRightToLeft },
        isVideoShowed ? (React.createElement(HeroSectionYoutube, { videoId: youtubeId, preview: backgroundImage.src, startTime: startTime })) : (React.createElement(ImageBgStyled, null,
            React.createElement(ImageAtom, { ...backgroundImage }),
            React.createElement(ImageMaskStyled, null))),
        React.createElement(HeroSectionContainer, null,
            React.createElement(Row, null,
                React.createElement(Col, { lg: titleGridColumns },
                    subtitle && React.createElement(SubtitleStyled, { color: colorCoreWhite1000 }, subtitle),
                    title && React.createElement(TitleStyled, { color: colorCoreWhite1000 }, title),
                    description && !isMobileView && React.createElement(DescriptionStyled, null, description))))));
}
